import { NgModule } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

const modules = [
  AutoCompleteModule,
  ButtonModule,
  CalendarModule,
  CardModule,
  DialogModule,
  ListboxModule,
  MultiSelectModule,
  OverlayPanelModule,
  SidebarModule,
  TableModule,
  ToastModule,
  TooltipModule,
  RadioButtonModule,
  TabViewModule,
  ProgressBarModule,
  SelectButtonModule,
  CheckboxModule,
  MenuModule
];

@NgModule({
  declarations: [],
  imports: modules,
  exports: modules
})
export class PrimeNgModule {}
